import { GET_BANNERS_ERROR, GET_BANNERS_START, GET_BANNERS_SUCCESS } from '../../types';

export default function get_banners(state, action) {
  switch (action.type) {
    case GET_BANNERS_START:
      return { ...state };
    case GET_BANNERS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_BANNERS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
